export default {
  upload: {
    dropFiles: "Drop files here to upload",
    delete: "Delete",
    deleteAllConfirm: "Are you sure you want to delete all files?",
    deleteConfirm: "Are you sure you want to delete {filename}?",
    deleteAllSuccess: "All files deleted successfully!",
    deleteSuccess: "{filename} deleted successfully!",
    deleteCancelled: "Deletion cancelled",
    warning: "Warning",
    cancel: "Cancel",
    fileSize: "Size: {size} KB",
  },
  appleorchard: {
    title: "Welcome to Varena Apple Orchard",
    about:
      "Nestled in the heart of the Campos em Cima da Serra, Rio Grande do Sul, Brazil. Varena Agropecuria has been a family-owned and operated orchard for over 30 years. Our commitment is to best orcharding practices and producing the highest quality apples.",
    apples:
      "At Varena, we grow a variety of apples to suit every taste. We have different types of apples, such as Gala, Fuji.",
  },
  appleFarm: {
    title: "Welcome to Varena Apple Orchard",
    about:
      "Nestled in the heart of the Campos em Cima da Serra, Rio Grande do Sul, Brazil. Varena Agropecuria has been a family-owned and operated orchard for over 30 years. Our commitment is to best orcharding practices and producing the highest quality apples.",
    apples:
      "At Varena, we grow a variety of apples to suit every taste. We have different types of apples, such as Gala, Fuji.",
  },
  test: {
    title: "i18n Test View",
    description: "This is a test view to demonstrate i18n capabilities.",
    item1: "First item",
    item2: "Second item",
    item3: "Third item",
  },
  footer: {
    copyright: "© {year} Varena Agropecuaria Ltda. All rights reserved.",
  },
  table: {
    mdthisIsASwalAlert: "This is a Swal alert. Mode: {mode} - URL: {url}",
  },
  fujiApples: {
    title: "All About Fuji Apples",
    intro: "Here's all you need to know about sweet Fuji apples.",
    tips: {
      tip1: "Fuji apples are a relatively new variety. They were first bred in Japan in the late 1930s, but were only brought to the world market in 1962.",
      tip2: "They're the result of a successful cross between two American varieties, Red Delicious and Virginia Ralls Janet.",
      tip3: "Known for their sweetness, Fuji apples have one of the highest sugar contents of apples on the market at about 14g of sugar per 100g.",
      tip4: "Make sweet fuji apples even sweeter by using them in jellies and tea.",
      tip5: "They'll keep for three months in the fridge. Separate damaged apples to keep the others fresher for longer.",
      tip6: "Apple peel is a good source of pectin, a form of soluble fibre. Pectin can help lower cholesterol and blood sugar levels.",
      tip7: "Craving a late-night snack? An apple is a great choice as it's low GI (preventing blood sugar spikes) and full of fibre, which can help digestion (aiding sleep).",
      tip8: "To keep sliced apples from turning brown, soak them in a mixture of 1 tbs lemon juice to 1 cup water. Drain and store in a sealable plastic bag in the fridge for up to one week.",
      tip9: "Crisp fresh fuji apples are at their sweet juicy peak between April and October.",
      tip10:
        "Add finely sliced fuji apples to salads, cereal and coleslaw for freshness and crunch.",
    },
    funFacts: {
      title: "Fun Facts",
      fact1:
        "Many people think Fuji apples are named after Mount Fuji, but the name actually comes from Fujisaki, the Japanese town where they were developed.",
      fact2: "One large Fuji can give you 15 per cent of your daily vitamin C.",
      fact3: "Fujis are one of the best apples to freeze.",
      fact4:
        "Fujis are great for stuffing and roasting, as they hold their shape when cooked.",
    },
    reference: "Source: taste.com.au",
  },
  galaApples: {
    title: "All About Gala Apples",
    intro: "Here are 7 facts you probably didn't know about Gala Apples.",
    facts: {
      fact1: {
        title: "Origin",
        content:
          'Gala Apple is an old variety from Greytown, New Zealand, and is a selection made by JH Kidd from the cross between "Kidss Orange" and "Golden Delicious". It is the variety with the highest production in Washington state.',
      },
      fact2: {
        title: "Main Use",
        content:
          "Compared to other varieties, Gala Apple enhances its sweet touch when cooked. For this reason, it is recommended to eat raw, or cook sweet desserts like a baked pie.",
      },
      fact3: {
        title: "Global Demand",
        content:
          "It is one of the most planted varieties worldwide, thanks to its flavor, juicy and crispy pulp, good balance between sugars and acidity. They are often used to make the famous apple cider vinegar.",
      },
      fact4: {
        title: "Sweetness and Flavor",
        content:
          "It has a balanced sweetness with a small touch of acidity, with notes of lime, white tea, and currants. It is a fleshy apple.",
      },
      fact5: {
        title: "Easy Consumption",
        content:
          "They don't stain and don't fall apart, they are the ideal snack to consume anywhere, whether after meals or when you've forgotten your toothbrush.",
      },
      fact6: {
        title: "Hydration",
        content:
          "They are very refreshing and hydrate us almost without realizing it, they are perfect for keeping us fresh at all levels, physical and intellectual.",
      },
      fact7: {
        title: "Energy Contribution",
        content:
          "Gala Apple has a high content of vitamins and minerals, as well as carbohydrates (especially in the form of fructose), which is easier for the body to absorb and is ideal for maintaining good energy levels.",
      },
    },
    reference: "Source: manzanaswashington.com",
  },
  menu: {
    home: 'Home',
    welcome: 'Welcome',
    login: 'Login',
    about: 'About Us',
    excelEntryManager: 'Excel Entry Manager',
    irrigationDashboard: {
      title: 'Irrigation Dashboard'
    },
    appleVarieties: {
      title: 'Apple Varieties',
      gala: 'Gala Apples',
      fuji: 'Fuji Apples'
    },
    colheita: 'Picking',
    payloads: 'Payloads',
    map: 'orchard map',
    farmonaut: {
      title: 'Farmonaut',
      plantations: 'Plantations',
      fields: 'Fields',
      upload: 'Field Upload',
      uploadFile: 'File Upload',
      autoFix: 'Auto-Fix Upload',
      validate: 'Validate GeoJSON',
      transform: 'Transform',
      comparison: 'Comparison',
      assignment: 'Assignment',
      createFarmonautFields: 'Create Farmonaut Fields',
      health: 'Health Check'
    },
    playground: {
      title: 'Playground',
      table: 'Table',
      datatable: 'Datatable',
      upload: 'Upload',
      fibuInputChange: 'Fibu Input Change',
      segmented: 'Segmented',
      timeline: 'Timeline',
      setor: 'Setor',
      sampleUsage: 'Sample Usage',
      createPlantation: 'Create Plantation'
    },
    tests: {
      title: 'Tests',
      i18n: 'I18n Test'
    },
    test: {
      title: 'Test',
      formily: 'Formily Test'
    }
  },
  createPlantation: {
    title: 'Create New Plantation',
    setor: 'Setor',
    selectSetor: '-- Select a setor --',
    subtipo: 'Subtipo',
    selectSubtipo: '-- Select a subtipo --',
    filas: 'Filas',
    arvores: 'Árvores',
    optionalFields: 'Optional Fields',
    area: 'Area (ha)',
    plantasPorHa: 'Plantas por Ha',
    anoPlantado: 'Ano Plantado',
    anoFinal: 'Ano Final',
    origem: 'Origem',
    custoPlantacao: 'Custo Plantação',
    formaTreinamento: 'Forma Treinamento',
    cobertura: 'Cobertura',
    submit: 'Create Plantation',
    creating: 'Creating...',
    reset: 'Reset',
    activeWarning: 'This setor already has an active plantation. You cannot create a new one.',
    success: 'Plantation created successfully! ID: {id}',
    errorActive: 'Cannot create plantation: Setor already has an active plantation',
    errorGeneric: 'Failed to create plantation'
  },
  errors: {
    404: {
      title: "Page Not Found",
      message: "Sorry, the page you are looking for does not exist.",
    },
    403: {
      title: "Access Denied",
      message: "Sorry, you do not have permission to access this page.",
    },
    actions: {
      goHome: "Go to Home",
      goBack: "Go Back",
      login: "Login",
    },
  },
  excel: {
    edit: {
      title: "Edit Entry",
    },
    actions: {
      edit: "Edit",
      viewHistory: "View History"
    },
    fields: {
      id: "ID",
      date: "Date",
      value: "Value",
      description: "Description",
      lastModified: "Last modified",
      newDescription: "New Description",
      existingDescription: "Existing Description",
      selectDescription: "Select a description"
    },
    history: {
      title: 'History - {descricao}',
      chartTitle: 'Historic {timeGrouping}',
      detailed: 'Detailed',
      monthly: 'Monthly',
      yearly: 'Yearly'
    },
    browser: {
      title: "Description History",
      selectTitle: "Select Description",
      selectMode: "Select Mode",
      viewHistory: "View History"
    },
  },
  common: {
    save: "Save Changes",
    cancel: "Cancel",
    backToList: "Back to List",
    delete: "Delete"
  },

  valve: {
    stopped: "Stopped",
    running: "Running",
    start: "Start",
    stop: "Stop",
    title: "Valves",
    name: "Valve",
    title_valves: "Valves"
  }, colheita: {
    title: 'Bin Quantity Entry',
    select_date: 'Select date',
    select_setor: 'Select setor',
    select_type: 'Select type',
    setor: 'Setor',
    gala: 'Gala',
    fuji: 'Fuji',
    quantity: 'Quantity',
    add_entry: 'Add Entry',
    review_submit: 'Review and Submit',
    entry: 'Entry',
    date: 'Date',
    type: 'Type',
    review_title: 'Review Entries',
    submit: 'Submit',
    cancel: 'Cancel',
    success: 'Success',
    error: 'Error',
    submit_success: 'Entries submitted successfully',
    submit_error: 'Failed to submit entries',
    validation_error: 'Please fill all fields correctly before submitting',
    filter_placeholder: 'Filter by Sector or Type',
    apple_variety: 'Apple Variety',
    total_quantity: 'Total Quantity',
    sector: 'Sector',
    dailyChart: 'Daily Quantities Chart',
    dailyTotals: 'Daily Total Quantities',
    noDataToDisplay: 'No data available to display in the chart',
    selectSector: 'Filter by Sector',
    dailyTotalsSector: 'Daily Total Quantities - Sector {sector}',
  },
  payloads: {
    title: 'Non Decoded Payloads',
    dailyQuantities: 'Daily Quantities',
    quantity: 'Quantity'
  },
  map: {
    selectMapData: 'Select Map Data',
    reloadMapData: 'Reload Map Data',
    mapData: 'Map Data',
    testCoordinates: 'Test Coordinates',
    enterGeoJsonCoordinatesArray: 'Enter GeoJSON Coordinates Array',
    invalidGeoJsonFormat: 'Invalid GeoJSON Format',
    enterValidGeoJson: 'Enter a Valid GeoJSON',
    editGeoJson: 'Edit GeoJSON',
    viewGeoJson: 'View GeoJSON',
    geoJsonForSetor: 'GeoJSON for Setor',
    mapCoordinates: 'Map Coordinates',
    clickedPosition: 'Clicked Position',
    longitude: 'Longitude',
    latitude: 'Latitude',
    area: 'Area',
    showAll: 'Show All',
    setoresInformation: 'Setores Information',
    showOnMap: 'Show on Map',
    addGeoJson: 'Add GeoJSON',
    calculateArea: 'Calculate Area',
    validFeatures: 'Valid Features',
    testPolygon: 'Test Polygon',
    enterGeoJsonForSetor: 'Enter GeoJSON for Setor',
    loadingSetoresInformation: 'Loading Setores Information...',
    viewDetails: 'View Details',
    debugInformation: 'Debug Information',
    copyCoordinates: 'Copy Coordinates',
    id: 'ID',
    calculateTotalArea: 'Calculate Total Area',
    totalArea: 'Total Area of Selected Setores'
  },
  farmonaut: {
    geoJsonEditor: {
      label: 'GeoJSON Geometry',
      hint: 'Polygon format: [[[lon, lat], [lon, lat], ...]]',
      valid: 'Valid GeoJSON'
    },
    cropCode: {
      label: 'Crop Code',
      selectPlaceholder: '-- Select crop code --',
      manualLabel: 'Or enter manually',
      manualPlaceholder: 'e.g. 35, 165',
      notInList: 'Code not in allowed list (will be validated on submit)'
    },
    response: {
      copy: 'Copy',
      error: 'Error',
      failed: 'Failed',
      invalid: 'Invalid',
      success: 'Success',
      validResult: 'Valid',
      response: 'Response'
    },
    fieldMap: {
      title: 'Field Map (OpenLayers)'
    },
    plantations: {
      title: 'Load Plantation Data',
      loadActive: 'Load Active Plantations',
      loading: 'Loading...',
      selectPlantation: 'Select Plantation',
      selectPlaceholder: '-- Select plantation --',
      details: 'Plantation Details',
      plantationId: 'Plantation ID',
      area: 'Area',
      anoPlantado: 'Planting Year',
      anoFinal: 'End Year',
      active: 'Active',
      farmonautId: 'Farmonaut ID',
      registered: 'Registered',
      notRegistered: 'Not registered',
      setorDetails: 'Sector Details',
      setorId: 'Sector ID',
      setorName: 'Sector Name',
      name: 'Name',
      setorArea: 'Sector Area',
      center: 'Center',
      hasGeoJSON: 'Has GeoJSON',
      yes: 'Yes',
      loadingFarmonaut: 'Loading Farmonaut field data...',
      farmonautFieldData: 'Farmonaut Field Data',
      farmonautData: 'Farmonaut Field Data',
      cropCode: 'Crop Code',
      copy: 'Copy',
      copyCropCode: 'Copy',
      fieldId: 'Field ID',
      fieldName: 'Field Name',
      fieldArea: 'Field Area',
      paymentType: 'Payment Type',
      sowingDate: 'Sowing Date',
      expired: 'Expired',
      paused: 'Paused',
      fullJson: 'Full JSON Response',
      showJson: 'Show full JSON',
      hideJson: 'Hide JSON',
      clickToLoad: 'Click "Load Active Plantations" to fetch plantations from the backend.',
      errorFarmonaut: 'Error loading Farmonaut data',
      sendToFarmonaut: 'Send to Farmonaut (Auto-Fix)',
      useInForms: 'Use in Forms',
      infoMessage: 'Click "Load Active Plantations" to fetch plantations from the backend.',
      noGeoJson: 'The selected plantation has no GeoJSON data in its sector'
    },
    fields: {
      title: 'Load Farmonaut Field by ID',
      description: 'Select a Farmonaut field ID to load and display field data.',
      fieldIdLabel: 'Farmonaut Field ID',
      selectField: 'Farmonaut Field ID',
      selectPlaceholder: '-- Select field --',
      loadingFieldIds: 'Loading field IDs...',
      errorFieldIds: 'Error loading field IDs',
      loadField: 'Load Field',
      reset: 'Reset',
      cropCodeSection: 'Crop Code',
      copyCropCode: 'Copy crop code',
      fieldDetails: 'Field Details',
      fieldId: 'Field ID',
      fieldName: 'Field Name',
      fieldArea: 'Field Area',
      centerCoordinates: 'Center Coordinates',
      paymentType: 'Payment Type',
      sowingDate: 'Sowing Date',
      fieldStatus: 'Field Status',
      expired: 'Expired',
      expiring: 'Expiring',
      paused: 'Paused',
      paid: 'Paid',
      healthData: 'Health Data',
      healthIndicatorLabel: 'Indicator',
      healthIndicatorPlaceholder: 'Select indicator',
      viewGraph: 'Graph',
      viewTable: 'Table',
      dateColumn: 'Date',
      valueColumn: 'Value',
      rawJson: 'Raw JSON',
      syncToInternal: 'Sync to internal DB',
      syncToInternalSuccess: 'Sync completed. Attempted: {attempted}, Skipped: {skipped}, Errors: {errors}',
      syncErrorNoPlantation: 'No plantation linked to this Farmonaut field.',
      updateAllIndices: 'Update all Farmonaut indices to DB',
      updateAllIndicesSuccess: 'Import completed. Processed: {processed}, Success: {success}, Errors: {errors}',
      updateAllIndicesError: 'Failed to update indices.',
      weatherData: 'Weather Data',
      yieldData: 'Yield Data',
      coordinates: 'Coordinates',
      sensedDays: 'Sensed Days'
    },
    upload: {
      title: 'Upload Field',
      fieldName: 'Field Name',
      address: 'Address',
      farmerId: 'Farmer ID',
      submit: 'Upload Field',
      uploading: 'Uploading...',
      reset: 'Reset'
    },
    fileUpload: {
      title: 'Upload GeoJSON File',
      fieldName: 'Field Name',
      geoJsonFile: 'GeoJSON File',
      selectFile: 'Select a .geojson or .json file',
      submit: 'Upload File',
      uploading: 'Uploading...',
      reset: 'Reset'
    },
    autoFix: {
      title: 'Upload with Auto-Fix',
      description: 'Uploads a field and automatically repairs common GeoJSON issues (LineString to Polygon, ring closure, etc.)',
      fieldName: 'Field Name',
      address: 'Address',
      farmerId: 'Farmer ID',
      hint: 'LineString geometries will be automatically converted to Polygon',
      submit: 'Upload with Auto-Fix',
      uploading: 'Uploading...',
      reset: 'Reset',
      repairedGeoJson: 'Repaired GeoJSON'
    },
    validate: {
      title: 'Validate GeoJSON',
      description: 'Validate GeoJSON without uploading to Farmonaut',
      fieldName: 'Field Name',
      cropCode: 'Crop Code',
      address: 'Address',
      farmerId: 'Farmer ID',
      submit: 'Validate',
      validating: 'Validating...',
      reset: 'Reset'
    },
    transform: {
      title: 'Convert to Farmonaut Format',
      description: 'Converts GeoJSON to Farmonaut format without uploading. Displays the transformed data structure.',
      fieldName: 'Field Name',
      address: 'Address',
      farmerId: 'Farmer ID',
      submit: 'Transform',
      transforming: 'Transforming...',
      reset: 'Reset',
      transformedGeoJson: 'Transformed GeoJSON (Farmonaut Format)',
      copyToClipboard: 'Copy to clipboard',
      copied: 'Copied!'
    },
    comparison: {
      title: 'Field & Plantation Comparison',
      description: 'Compare Farmonaut field data with plantation data on a single map',
      fieldId: 'Farmonaut Field ID (Optional)',
      farmonautFieldId: 'Farmonaut Field ID',
      selectFieldPlaceholder: '-- Select field (optional) --',
      selectPlantation: 'Select Plantation',
      selectPlantationPlaceholder: '-- Select plantation --',
      loadPlantations: 'Load Plantations',
      loadField: 'Load Farmonaut Field',
      loadFarmonautField: 'Load Farmonaut Field',
      loadPlantation: 'Load Plantation',
      loadComparison: 'Load Comparison',
      reset: 'Reset',
      farmonautField: 'Farmonaut Field (Blue)',
      farmonautFieldBlue: 'Farmonaut Field (Blue)',
      plantation: 'Plantation (Green)',
      plantationGreen: 'Plantation (Green)',
      plantationId: 'Plantation ID',
      setorName: 'Sector Name',
      area: 'Area',
      farmonautId: 'Farmonaut ID',
      notRegistered: 'Not registered',
      assignFarmonautId: 'Assign Farmonaut ID',
      assigning: 'Assigning...',
      comparisonMap: 'Comparison Map',
      legendFarmonaut: 'Farmonaut Field',
      legendPlantation: 'Plantation',
      loadingData: 'Loading data...',
      loadingFieldIds: 'Loading field IDs...',
      farmonautFieldError: 'Farmonaut field error',
      plantationError: 'Plantation error',
      assignmentError: 'Assignment error'
    },
    validation: {
      description: 'Validate GeoJSON without uploading to Farmonaut',
      fieldName: 'Field Name',
      fieldNamePlaceholder: 'Enter field name',
      cropCode: 'Crop Code',
      cropCodePlaceholder: 'e.g. 35, 165',
      cropCodeHint: 'Code will be validated on submit',
      address: 'Address',
      addressPlaceholder: 'Optional address',
      farmerId: 'Farmer ID',
      farmerIdPlaceholder: 'Optional farmer ID',
      validate: 'Validate',
      reset: 'Reset'
    },
    createFarmonaut: {
      title: 'Create Farmonaut Fields from Plantations',
      description: 'Select plantations without Farmonaut IDs and create new Farmonaut fields from their GeoJSON data.',
      loading: 'Loading...',
      refresh: 'Refresh Plantations',
      withoutId: '{count} plantation(s) without Farmonaut ID',
      noPlantations: 'No plantations without Farmonaut IDs found.',
      allLinked: 'All active plantations have been linked to Farmonaut fields.',
      plantation: 'Plantation',
      created: 'Created',
      creating: 'Creating...',
      error: 'Error',
      plantationDetails: 'Plantation Details',
      geojsonPreview: 'GeoJSON Preview',
      createField: 'Create Farmonaut Field',
      createButton: 'Create Farmonaut Field',
      successTitle: 'Successfully created Farmonaut field!',
      fieldId: 'Farmonaut Field ID',
      linked: 'The plantation has been linked to this Farmonaut field.',
      transformDetails: 'View transformation details',
      noGeojson: 'No - Cannot create Farmonaut field',
      noGeojsonAlert: 'Selected plantation has no GeoJSON data in its sector.',
      noDesignacao: 'Plantation setor has no name (designacao). Cannot create Farmonaut field.',
      confirmTitle: 'Create Farmonaut field?',
      confirmMessage: 'Create Farmonaut field for Plantation {id}? Setor: {name}, Crop Code: {cropCode}. This will create a new Farmonaut field and link it to this plantation.'
    },
    assignment: {
      title: 'Field & Plantation Assignment',
      description: 'Assign Farmonaut field IDs to plantations. Each field has its own map for visual comparison.',
      loadingSummaries: 'Loading field summaries and plantations...',
      noFields: 'No Farmonaut fields found.',
      fieldId: 'Field ID',
      assignedTo: 'Assigned to Plantation {id}',
      notAssigned: 'Not assigned',
      selectPlantation: '-- Select plantation --',
      assign: 'Assign',
      assigning: 'Assigning...',
      successAssigned: 'Successfully assigned!',
      loadingMap: 'Loading map data...'
    },
    health: {
      title: 'Health Check',
      checkHealth: 'Check Status',
      checking: 'Checking...',
      infoMessage: 'Click "Check Status" to verify if the Farmonaut service is running.'
    },
    common: {
      loading: 'Loading...',
      error: 'Error',
      noData: 'N/A',
      yes: 'Yes',
      setor: 'Sector',
      plantation: 'Plantation',
      area: 'Area',
      planted: 'Planted'
    }
  }
};
